/** The site's data sources page in the client portal. */
export function dataSourcesPath(clientId: number, locationId: number): string {
    return `/c/${clientId}/location/${locationId}/data-sources`;
}
